import styled from '@emotion/styled';
import { colorConstants } from 'config/colorConstants';

export const StyledTableWrapper = styled.div`
    border: 1px solid ${colorConstants.borderGreyAlt};
    border-radius: 8px;
    overflow: hidden;

    .ant-table {
        font-size: 14px;
    }

    .ant-table-thead > tr > th {
        background: #fafafa;
        border-bottom: 1px solid #f0f0f0;
        color: #18181b;
        font-size: 14px;
        font-weight: 600;
        height: 54px;
        padding: 0 12px;
    }

    .ant-table-tbody > tr > td {
        border-bottom: 1px solid #f0f0f0;
        color: #18181b;
        font-size: 14px;
        font-weight: 400;
        height: 54px;
        padding: 0 12px;
    }

    .ant-table-expanded-row > td {
        padding: 0 !important;
        background: #fafafa !important;
    }

    .price-simulator-v3-scenario-table .ant-table-tbody > tr > td {
        background: #fafafa;
        height: 54px !important;
        padding: 0 12px !important;
    }

    .price-simulator-v3-scenario-table .ant-table-selection-column {
        width: 48px !important;
        min-width: 48px !important;
        padding-right: 4px !important;
    }

    .ant-table-cell::before {
        display: none !important;
    }

    .price-simulator-v3-filter-dropdown {
        background: transparent !important;
        box-shadow: none !important;
        padding: 0 !important;
    }

    .price-simulator-v3-action-dropdown .ant-dropdown-menu {
        padding: 4px;
        border-radius: 6px;
        box-shadow:
            0 6px 16px rgba(0, 0, 0, 0.08),
            0 3px 6px rgba(0, 0, 0, 0.12),
            0 9px 28px rgba(0, 0, 0, 0.05);
    }

    .price-simulator-v3-action-dropdown .ant-dropdown-menu-item {
        height: 32px;
        border-radius: 4px;
        padding: 5px 12px;
    }

    .price-simulator-v3-action-dropdown .ant-dropdown-menu-title-content {
        font-size: 14px;
        line-height: 22px;
    }

    .price-simulator-v3-project-table .ant-table-thead {
        position: sticky;
        top: 0;
        z-index: 20;
    }

    .price-simulator-v3-project-table .ant-table-thead > tr > th {
        position: sticky;
        top: 0;
        z-index: 21;
        background: #fafafa !important;
    }
`;
